import React, { FC } from 'react';
import styled from 'styled-components';
import { TextArea } from 'react-uforms';
import { colors } from '@ch/common/const/color';
import { form as s } from '@ch/common/const/form-element';
import { spacingStyle } from '@ch/common/const/spacing';
import { FormTextAreaProps, FormTextAreaWrapProps } from './types';

const TextAreaChild: FC<FormTextAreaProps> = props => {
  return <TextArea {...props} hideError={true} />;
};

const FormTextAreaWrapChild: FC<FormTextAreaWrapProps> = props => {
  const { className, children } = props;
  return <div className={className}>{children}</div>;
};

export const FormTextAreaStyled = styled(TextAreaChild)<FormTextAreaProps>`
  width: 100%;
  display: block;
  font-size: ${({ $size }) => s.input[$size].fontSize}px;
  line-height: ${({ $size }) => s.input[$size].lineHeight}px;
  border-radius: ${({ $size }) => s.input[$size].radius}px;
  padding: ${({ $size }) => `${s.input[$size].padding.map(e => `${e}px`).join(' ')}`};
  border: 1px solid ${({ $error }) => ($error ? colors.error : colors.grayMedium)};
  &:focus {
    border-color: ${colors.primary};
  }
  &:disabled,
  &:read-only {
    color: ${colors.grayDark};
    background-color: ${colors.grayUltraLight};
  }
`;

export const FormTextAreaWrapStyled = styled(FormTextAreaWrapChild)<FormTextAreaWrapProps>`
  position: relative;
  ${props => spacingStyle(props)}
`;
